import GameBoard from './components/GameBoard';
import './App.css';

function App() {
  return (
    <div className="App">
        <GameBoard></GameBoard>
    </div>
  );
}

export default App;
